module.exports = __webpack_public_path__ + "img/about-us-image-min.0dd7ef8d.png";